import { useMutation } from "react-query";
import http from "shared/http";

export interface LinkResource {
  id: number;
  title: string;
  url: string;
  resourceTier?: string;
  summary?: string;
  categories: string[];
  agencies?: string[];
  roles?: string[];
  isActive?: boolean;
  mode?: "NONE" | "WINDOW" | "TAB";
}

export const useUpsertLinkMutation = () => {
  return useMutation(async (link: LinkResource) => {
    if (link.id > 0) {
      return await http.putAsync(`admin/links/${link.id}`, link);
    }
    return await http.postAsync("admin/links", link);
  });
};

export const useDeleteLinkMutation = () => {
  return useMutation(async (linkId: number) => {
    return await http.deleteAsync("admin/links", linkId);
  });
};
